import { createElement, Component } from 'react';
import { string, number, func, bool } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { f as _defineProperty, e as _inheritsLoose, g as _assertThisInitialized } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import times from 'lodash/times';
import { Rating as Rating$1 } from './styled.js';
import RatingStar from './RatingStar.js';
export { default as RatingStar, ratingStarDefaultProps, ratingStarPropTypes } from './RatingStar.js';
var ratingPropTypes = {
  className: string,
  size: string,
  defaultRating: number,
  maxRating: number,
  onRate: func,
  disabled: bool
};
var ratingDefaultProps = {
  className: undefined,
  size: 'default',
  defaultRating: 0,
  maxRating: 5,
  onRate: undefined,
  disabled: false
};

var Rating = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Rating, _React$Component);

  function Rating() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      rating: _this.props.defaultRating || 0,
      isSelecting: false,
      selectedIndex: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleStarClick", function (index) {
      var _this$props = _this.props,
          onRate = _this$props.onRate,
          disabled = _this$props.disabled,
          maxRating = _this$props.maxRating;
      var rating = index + 1;

      if (!disabled) {
        _this.setState({
          rating: rating
        });

        onRate && onRate({
          rating: rating,
          maxRating: maxRating
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleStarMouseOver", function (index) {
      var disabled = _this.props.disabled;
      !disabled && _this.setState({
        isSelecting: true,
        selectedIndex: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        isSelecting: false
      });
    });

    return _this;
  }

  var _proto = Rating.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        size = _this$props2.size,
        maxRating = _this$props2.maxRating;
    var _this$state = this.state,
        rating = _this$state.rating,
        selectedIndex = _this$state.selectedIndex,
        isSelecting = _this$state.isSelecting;
    return createElement(Rating$1, {
      className: className,
      onMouseLeave: this.handleMouseLeave
    }, times(maxRating, function (index) {
      return createElement(RatingStar, {
        key: index,
        active: isSelecting ? selectedIndex >= index : rating >= index + 1,
        "aria-label": "" + (index + 1),
        onClick: function onClick() {
          return _this2.handleStarClick(index);
        },
        onMouseEnter: function onMouseEnter() {
          return _this2.handleStarMouseOver(index);
        },
        size: size
      });
    }));
  };

  return Rating;
}(Component); // @ts-ignore


_defineProperty(Rating, "propTypes", ratingPropTypes);

_defineProperty(Rating, "defaultProps", ratingDefaultProps);

var C = Rating;
export default C;
export { C as Rating, ratingDefaultProps, ratingPropTypes };